import React from 'react';
import Styled from 'styled';
import { observer } from 'mobx-react';
import EmphasizedTextView from 'four-nets/ui/emphasized-text-view';
import defaultStyles from './autocomplete-item-view.scss';

@Styled(defaultStyles)
@observer
class AutocompleteItemView extends React.Component {
    render() {
        const { src, title, subtitle, searchValue, alt, styles, selected } = this.props;

        const classNames = [styles.autocompleteItem];

        if (selected) {
            classNames.push(styles.selected);
        }

        return (
            <span className={classNames.join(' ')}>
                {src ? (
                    <span key='image' className={styles.imageWrapper}>
                        <img className={styles.image} alt={alt || 'avatar'} src={src} />
                    </span>
                ) : null}
                <span className={styles.textWrapper}>
                    <span key='text' className={styles.text}>
                        <EmphasizedTextView text={title} emphasize={searchValue} />
                    </span>
                    <span key='subtitle' className={styles.subtitle}>
                        {subtitle}
                    </span>
                </span>
            </span>
        );
    }
}

export default AutocompleteItemView;
